import React, { useId, useState } from 'react'
import { ConfirmDialog } from '../../../../shared/sso-workspace/confirm-dialog'
import { serverMessage } from '../../../../shared/error/server-message'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { DEFAULT_GRACE, GRACE_CHOICES } from '../../org/api-keys/key-words'
import { rotateKey } from './packages-api'

// Rotates a publish key: a new secret, shown once, and a grace for the old.
export const RotateKeyDialog = ({ packageName, keyRow, onCancel, onRotated }) => {
  const groupId = useId()
  const [grace, setGrace] = useState(DEFAULT_GRACE)
  const [busy, setBusy] = useState(false)
  const [error, failure, setError] = useErrorLine()

  const cancel = () => { setError(null); onCancel() }
  const rotate = async () => {
    if (busy || !keyRow) return
    setBusy(true)
    setError(null)
    try {
      const answer = await rotateKey(packageName, keyRow.id, { grace_hours: grace })
      setBusy(false)
      onRotated(answer)
    } catch (err) {
      setBusy(false)
      setError(serverMessage(err, "The key couldn't be rotated."), err)
    }
  }

  return (
    <ConfirmDialog open={Boolean(keyRow)} title={keyRow ? `Rotate "${keyRow.name}"?` : ''}
      body="A new secret is made and shown once. Choose how long the old secret keeps working, so CI can switch over first."
      confirmText="Rotate key" confirmClassName="btn sw-btn-primary" busy={busy} error={error} failure={failure}
      onConfirm={rotate} onCancel={cancel}>
      <div className="sw-label" id={groupId}>The old secret keeps working</div>
      <div className="ak-choices mb-3" role="radiogroup" aria-labelledby={groupId}>
        {GRACE_CHOICES.map(choice =>
          <label key={choice.hours}>
            <input type="radio" name={groupId} checked={grace === choice.hours} onChange={() => setGrace(choice.hours)} />
            {choice.label}
          </label>)}
      </div>
    </ConfirmDialog>
  )
}
